import { Order } from "@/api/controller/order";
import { createAsyncFetchThunk } from "@/store/utils";

export const getOrderStatus = createAsyncFetchThunk(
  "orders/getOrderStatus",
  Order.getOrderStatus,
);
